<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :visibleCreate="true" :loading="loading" @stored="stored">
          <template v-slot:action="{ item }">
            <v-btn class="mr-2" depressed small @click.stop="updated(item)" color="primary">編集</v-btn>
            <v-btn class="mr-2" depressed small @click.stop="deleted(item)" color="error">削除</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <!-- 削除ボタン押下後に表示されるダイアログ -->
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
        @deleted="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import SubcontractorApi from "@/api/subcontractor-api";
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CustomDialog from "@/components/custom_ui/CustomDialog";

  export default {
    name: "SubcontractorMaster",
    components: {
      CustomDataTable,
      CustomDialog
    },
    data: () => ({
      // 共通コンポーネント: データテーブル関連
      loading: false,
      tableName: '外注作業者情報',
      headers: [
        { text: '氏名', value: 'subcontractor_name', sortable: false, align: 'left'},
        { text: '取引先', value: 'suppliers_name', sortable: false, align: 'left'},
        { text: '単価', value: 'unit_price', sortable: false, align: 'right'},
        { text: 'アクション', value: 'action', sortable: false, align: 'left'},
      ],
      items: [],

      // 削除ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,
      deleteId: null
    }),
    created () {
      this.initialize ();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.subcontractorApi = new SubcontractorApi();
        const promise = this.subcontractorApi.list();
        promise.then((response) => {
          this.items = response.data.body.subcontractor_list;
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },
      // 新規作成ボタン押下時のイベント
      stored () {
        this.$router.push({ name: 'CreateSubcontractorMaster' });
      },
      // 編集ボタン押下時イベント
      updated (item) {
        this.$router.push({ name: 'EditSubcontractorMaster', params: { id: item.id } });
      },
      // 削除ボタン押下時イベント
      deleted (item) {
        this.deleteId = item.id;
        this.dialogTitle = '削除しますか？';
        this.dialogItems = [
          { name: "氏名", value: item.subcontractor_name },
          { name: "取引先", value: item.suppliers_name },
          { name: "単価", value: item.unit_price },
        ];
        this.dialogDrawer = true;
      },
      dialogCancel () {
        this.dialogDrawer = false;
      },
      // ダイアログ削除ボタン押下時イベント
      submit() {
        this.isLoading();
        // 外注作業者IDを選択済みアイテム情報から取得
        const promise = this.subcontractorApi.delete(this.deleteId);
        promise.then((response) => {
            this.items = this.items.filter((item) => {
                return (item.id !== this.deleteId);
            });
            this.deleteId = null;
            this.dialogDrawer = false;
            this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
    },
  };
</script>
